import React, { useEffect, useRef } from "react";

import { Burger } from "@mantine/core";
import { useDisclosure } from "@mantine/hooks";
import { IconBrandWhatsapp } from "@tabler/icons-react";
import { useNavigate } from "react-router-dom";

const MHeader = () => {
  const navigate = useNavigate();

  const [opened, { toggle }] = useDisclosure(false);

  const phoneMenuListRef = useRef<HTMLDivElement>(null);
  const burgerIconRef = useRef<HTMLButtonElement>(null);
  const headerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    burgerIconRef.current?.addEventListener("click", () => {
      opened
        ? (phoneMenuListRef.current!.style.transform = "translate(0, -120%)")
        : (phoneMenuListRef.current!.style.transform = "translate(0, 0)");
    });
  }, [opened]);

  useEffect(() => {
    window.scrollY &&
      window.addEventListener("scroll", () => {
        if (window.scrollY > 100)
          headerRef.current!.style.backgroundColor = "rgb(255,255,255)";
        else headerRef.current!.style.backgroundColor = "rgba(255,255,255,0)";
      });
  }, []);

  const menuOnclick = (link: string) => {
    let menuHeight =
      document.querySelector<HTMLDivElement>("#header")!.offsetHeight;

    var location = document.querySelector<HTMLDivElement>(link)!.offsetTop;

    window.scrollY &&
      window.scrollTo({
        top: location - menuHeight + 120,
        behavior: "smooth",
      });
  };

  const phoneMenuOnclick = (link: string) => {
    let menuHeight =
      document.querySelector<HTMLDivElement>("#header")!.offsetHeight;

    var location = document.querySelector<HTMLDivElement>(link)!.offsetTop;

    window.scrollY &&
      window.scrollTo({
        top: location - menuHeight,
        behavior: "smooth",
      });

    toggle();
    phoneMenuListRef.current!.style.transform = "translate(0, -100%)";
  };
  return (
    <header className="fixed left-0 top-0 w-full h-fit z-40 bg-white">
      <div
        ref={headerRef}
        id="header"
        className="relative w-full h-fit px-[calc((100%-var(--container))/5)] 3xl:px-[calc((100%-var(--container))/2)] max-h-20 lg:max-h-32 py-2 overflow-hidden z-40 transition-all duration-300"
      >
        <div className="relative w-full h-full mx-auto flex justify-between items-center gap-6 xl:gap-16 2xl:gap-20">
          <Burger
            ref={burgerIconRef}
            opened={opened}
            onClick={toggle}
            className="block lg:hidden"
            size="md"
            color="green"
          />
          <div className="relative w-auto h-auto">
            <img
              alt="logo"
              onClick={() => navigate("/")}
              className="!relative w-full h-full max-w-md max-h-16 lg:max-h-20 py-1 object-contain cursor-pointer"
              src="/images/logo.png"
              width={581}
              height={232}
            />
          </div>
          <div className="block lg:hidden relative w-fit h-fit p-1 mx-1 rounded-full">
            <IconBrandWhatsapp
              onClick={() => {
                window.location.href = "tel:010-9806-4573";
              }}
              size={30}
              stroke={1}
              className="text-primary"
            />
          </div>
          <ul className="hidden relative w-fit h-fit text-center lg:flex justify-between items-center justify-items-center gap-8 xl:gap-16 3xl:gap-20 cursor-pointer">
            <li onClick={() => menuOnclick("#about")}>
              <p className="2xl:text-xl">
                몽&nbsp;<span className="text-point">★</span>&nbsp;땅
              </p>
            </li>
            <li onClick={() => menuOnclick("#service")}>
              <p className="2xl:text-xl">서비스&nbsp;목록</p>
            </li>
            <li onClick={() => menuOnclick("#blog")}>
              <p className="2xl:text-xl">작업사례</p>
            </li>
            <li onClick={() => menuOnclick("#review")}>
              <p className="2xl:text-xl">고객후기</p>
            </li>
            <li onClick={() => menuOnclick("#contact")}>
              <p className="2xl:text-xl">견적문의</p>
            </li>
          </ul>
          <div className="hidden lg:block relative w-fit h-fit">
            <img
              onClick={() => {
                window.location.href = "tel:010-9806-4573";
              }}
              className="!relative w-full h-full max-h-12 xl:max-h-14 object-contain cursor-pointer"
              alt="button"
              src="images/rightNum.png"
              width={1653}
              height={263}
            />
          </div>
        </div>
      </div>
      <div
        ref={phoneMenuListRef}
        className="block lg:hidden fixed top-[60px] left-0 w-full h-full -translate-y-full transition-transform duration-500 z-30"
      >
        <ul className="border-b bg-[var(--background-color)] text-font">
          <li
            onClick={() => phoneMenuOnclick("#about")}
            className="border-b py-4 text-center"
          >
            <p className="text-base">
              몽&nbsp;<span className="text-point">★</span>&nbsp;땅
            </p>
          </li>
          <li
            onClick={() => phoneMenuOnclick("#service")}
            className="border-b py-4 text-center"
          >
            <p className="text-base">서비스&nbsp;목록</p>
          </li>
          <li
            onClick={() => phoneMenuOnclick("#blog")}
            className="border-b py-4 text-center"
          >
            <p className="text-base">작업사례</p>
          </li>
          <li
            onClick={() => phoneMenuOnclick("#review")}
            className="border-b py-4 text-center"
          >
            <p className="text-base">고객후기</p>
          </li>
          <li
            onClick={() => phoneMenuOnclick("#contact")}
            className="border-b py-4 text-center"
          >
            <p className="text-base">견적문의</p>
          </li>
        </ul>
      </div>
    </header>
  );
};

export default MHeader;
